import { useEffect } from 'react';
export const useListener = ({ target: { current }, event, listener, options, }) => useEffect(() => {
    current === null || current === void 0 ? void 0 : current.addEventListener(event, listener, options);
    return () => current === null || current === void 0 ? void 0 : current.removeEventListener(event, listener, options);
}, [current, event, listener]);
